/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type NotFoundErrorPageType from '@jira/platform__not-found-error-page/src/NotFoundErrorPage.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyNotFoundErrorPage: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof NotFoundErrorPageType
>(
	() =>
		import(
			/* webpackChunkName: "async-error-pages-not-found", jiraSpaEntry: "async-error-pages-not-found" */ '@jira/spa-apps__error-pages-not-found/src/ErrorPagesNotFoundPage.tsx'
		),
);

const AsyncNotFoundErrorPage = (): React.JSX.Element => (
	<LazyPage Page={LazyNotFoundErrorPage} pageId="errors-404" shouldShowSpinner={false} />
);

export default AsyncNotFoundErrorPage;
